{
  "subjects": {
    "mathematics": "Mathematics",
    "science": "Science",
    "english": "English",
    "history": "History",
    "geography": "Geography",
    "arts": "Arts",
    "music": "Music",
    "physicalEducation": "Physical Education",
    "computerScience": "Computer Science"
  },
  "grades": {
    "kindergarten": "Kindergarten",
    "elementary": "Elementary",
    "middle": "Middle School",
    "high": "High School",
    "grade": "Grade {{number}}"
  },
  "lesson": {
    "title": "Lesson",
    "objectives": "Learning Objectives",
    "duration": "Duration",
    "difficulty": "Difficulty",
    "prerequisites": "Prerequisites",
    "materials": "Materials",
    "instructions": "Instructions",
    "activities": "Activities",
    "assessment": "Assessment",
    "complete": "Complete Lesson",
    "next": "Next Lesson",
    "previous": "Previous Lesson"
  },
  "assessment": {
    "title": "Assessment",
    "type": {
      "quiz": "Quiz",
      "test": "Test",
      "homework": "Homework",
      "project": "Project",
      "presentation": "Presentation"
    },
    "status": {
      "notStarted": "Not Started",
      "inProgress": "In Progress",
      "submitted": "Submitted",
      "graded": "Graded",
      "returned": "Returned"
    },
    "score": "Score",
    "grade": "Grade",
    "feedback": "Feedback",
    "attempts": "Attempts",
    "timeLimit": "Time Limit",
    "submit": "Submit Assessment",
    "save": "Save Progress"
  },
  "progress": {
    "title": "Progress",
    "overall": "Overall Progress",
    "weekly": "Weekly Progress",
    "monthly": "Monthly Progress",
    "completed": "Completed",
    "inProgress": "In Progress",
    "notStarted": "Not Started",
    "streak": "Learning Streak",
    "achievements": "Achievements",
    "certificates": "Certificates"
  }
}
